import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { Observable, throwError } from "rxjs";
import { catchError, switchMap, take } from "rxjs/operators";
import { UserDataService } from "../user/user.service";
import { TokenStorageService } from "./token-storage.service";

@Injectable({
  providedIn: "root",
})
export class TokenAuthInterceptor implements HttpInterceptor {
  constructor(
    private tokenStorage: TokenStorageService,
    private userService: UserDataService,
    private modalController: ModalController,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return this.tokenStorage.token$.pipe(
      take(1),
      switchMap((token) => {
        if (token) {
          req = req.clone({
            headers: req.headers.set("Authorization", `Bearer ${token}`),
          });
        }
        return next.handle(req).pipe(
          catchError((error: HttpErrorResponse) => {
            if (error.status == 401) {
              this.tokenStorage.token$
                .pipe(take(1))
                .toPromise()
                .then(async (token) => {
                  if (token) {
                    const openModal = await this.modalController.getTop();
                    if (openModal) {
                      await this.modalController.dismiss();
                    }
                    await this.userService.logout();
                  }
                });
            }
            return throwError(error);
          })
        );
      })
    );
  }
}
